// src/features/pdf/pdf-compressor/CompressionResultDisplay.tsx
import React from 'react';
import { Box, Typography, Paper, useTheme, Chip } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { formatBytes } from '../utils/formatter';

interface CompressionResultDisplayProps {
    originalSize: number;
    newSize: number;
}

const CompressionResultDisplay: React.FC<CompressionResultDisplayProps> = ({ originalSize, newSize }) => {
    const theme = useTheme();
    const sizeReduction = originalSize > 0 ? ((originalSize - newSize) / originalSize) * 100 : 0;
    const reductionPercentage = sizeReduction.toFixed(1);

    return (
        <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', width: '100%', flexWrap: 'wrap', gap: 2 }}>
                {/* Original Size */}
                <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="caption" color="text.secondary">Original</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                        <PictureAsPdfIcon sx={{ color: 'text.secondary' }} />
                        <Typography variant="h6">{formatBytes(originalSize)}</Typography>
                    </Box>
                </Box>

                <ArrowForwardIcon sx={{ color: 'text.primary', fontSize: '2rem' }} />

                {/* New Size */}
                <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="caption" color="text.secondary">Compressed</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                        <PictureAsPdfIcon sx={{ color: theme.palette.success.main }} />
                        <Typography variant="h6" color="success.main">{formatBytes(newSize)}</Typography>
                    </Box>
                </Box>
            </Box>
            <Chip
                label={`You saved ${formatBytes(originalSize - newSize)} (${reductionPercentage}%)!`}
                color="success"
                variant="filled"
                sx={{ fontWeight: 'bold' }}
            />
        </Paper>
    );
};

export default CompressionResultDisplay;